<template>
  <v-dialog
    v-model="display"
    width="500"
  >
    <v-card>
      <v-card-title class="text-h5 grey lighten-2">
        {{ title }}
      </v-card-title>
      <br>
      <v-card-text class="prompt-text">
        {{ message }}
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions v-if="!finished">
        <v-spacer></v-spacer>
        <v-btn
          color="red"
          text
          @click="close"
        >
          CANCEL
        </v-btn>
        <v-btn
          v-if="!loading"
          color="green"
          text
          @click="submit"
        >
          SUBMIT
        </v-btn>
        <v-progress-circular
          v-else
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-card-actions>
      <v-card-actions v-else>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          text
          @click="close"
        >
          CLOSE
        </v-btn>
      </v-card-actions>

      <v-card-text 
        v-if="res" 
        class="status-message"
        >
        <div :class="res.code">{{ res.msg }}</div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'PromptDialog',
  props: {
    display: {
      type: Boolean,
      required: true
    },
    closeTarget: {
      type: String,
      required: true
    },
    submitTarget: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    message: {
      type: String,
      required: true
    },
    state: {
      type: Boolean,
      required: true
    },
    res: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  data() {
    return {
      dialog: false,
      loading: false,
      finished: false
    }
  },
  watch: {
    state() {
      if(this.state) {
        this.loading = false;
        this.finished = true;
      }
    }
  },
  mounted() {
    this.dialog = this.display;
  },
  methods: {
    close() {
      this.finished = false;
      this.$emit(`${this.closeTarget}`.toString());
    },
    submit() {
      this.loading = true;
      this.$emit(`${this.submitTarget}`.toString());
    }
  }
}
</script>

<style lang="scss" scoped>
  .prompt-text {
    font-size: 1em;
  }
  .status-message {
    text-align: center;
    font-size: 1em;
  }
  .green {
    color: green !important;
    background-color: white !important;
  }
  .red {
    color: red !important;
    background-color: white !important;
  }
</style>